var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlObjective(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_4721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V48H48V0H0ZM45.9533 45.9533H2.04667V2.04667H45.9533V45.9533Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 44.0966C27.9609 44.0972 31.8332 42.9232 35.127 40.7231C38.4208 38.5229 40.9882 35.3954 42.5045 31.7361C44.0208 28.0767 44.4179 24.0499 43.6455 20.1649C42.8731 16.2799 40.966 12.7112 38.1654 9.91008C35.3648 7.10896 31.7963 5.20128 27.9115 4.42827C24.0266 3.65527 19.9997 4.05167 16.3401 5.56734C12.6805 7.08302 9.5526 9.64988 7.3519 12.9433C5.15119 16.2368 3.97656 20.1088 3.97656 24.0699C3.98186 29.3791 6.09304 34.4694 9.84691 38.2239C13.6008 41.9783 18.6907 44.0904 23.9999 44.0966ZM23.9999 6.09656C27.5556 6.0959 31.0317 7.14973 33.9885 9.12478C36.9452 11.0998 39.2498 13.9074 40.6109 17.1923C41.9719 20.4773 42.3282 24.092 41.6346 27.5795C40.9411 31.0669 39.2289 34.2704 36.7147 36.7846C34.2004 39.2989 30.9969 41.0111 27.5095 41.7046C24.022 42.3982 20.4073 42.0419 17.1223 40.6809C13.8374 39.3198 11.0298 37.0152 9.05479 34.0584C7.07974 31.1017 6.0259 27.6256 6.02656 24.0699C6.03362 19.3052 7.92949 14.7377 11.2986 11.3686C14.6677 7.99949 19.2352 6.10361 23.9999 6.09656Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0266 8.46338H22.9766V13.3467H25.0266V8.46338Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0266 34.8667H22.9766V39.75H25.0266V34.8667Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6468 23.0801H34.7634V25.1301H39.6468V23.0801Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24 23.0801H8.35669V25.1301H13.24V23.0801Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3099 34.7966C13.4041 34.8927 13.5167 34.9688 13.641 35.0203C13.7653 35.0719 13.8987 35.0978 14.0333 35.0966C14.2043 35.0969 14.3728 35.0546 14.5233 34.9733L27.4066 27.9533C27.4987 27.9012 27.582 27.8348 27.6533 27.7566C27.732 27.6858 27.7985 27.6025 27.8499 27.5099L34.8499 14.6299C34.9569 14.4357 34.9978 14.212 34.9667 13.9925C34.9355 13.773 34.8339 13.5695 34.6771 13.4128C34.5203 13.256 34.3169 13.1544 34.0974 13.1232C33.8779 13.092 33.6542 13.133 33.4599 13.2399L20.5966 20.2566C20.5041 20.308 20.4207 20.3745 20.3499 20.4533C20.2717 20.5246 20.2054 20.6078 20.1533 20.6999L13.1333 33.5833C13.0272 33.7773 12.9871 34.0006 13.0189 34.2194C13.0508 34.4383 13.1529 34.6408 13.3099 34.7966ZM31.4033 16.7033L26.7033 25.3333L22.7799 21.3999L31.4033 16.7033ZM21.2966 22.8866L25.2199 26.8099L16.5966 31.5099L21.2966 22.8866Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_4721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlObjective);
export default __webpack_public_path__ + "static/media/control-objective.5538bb1d8728ce728634948919649cf9.svg";
export { ForwardRef as ReactComponent };